'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

var _lodash = require('lodash.uniqueid');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nativeInputCheckedSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'checked').set;

if (!nativeInputCheckedSetter) {
    nativeInputCheckedSetter = function nativeInputCheckedSetter(value) {
        this.checked = value;
    };
}

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;


        _this._id = (0, _lodash2.default)('switchCheckbox_');

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.error) + String(this.props.disabled) + String(this.props.checked);
        }
    }, {
        key: '_createRef',
        value: function _createRef(el) {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(el);
            }

            this.nativeElement = el;

            return this;
        }
    }, {
        key: '_check',
        value: function _check() {
            if (!this.props.disabled) {
                this.value = true;
            }
            return this;
        }
    }, {
        key: '_uncheck',
        value: function _uncheck() {
            if (!this.props.disabled) {
                this.value = false;
            }
            return this;
        }
    }, {
        key: 'value',
        get: function get() {
            return this.props.checked;
        },
        set: function set(checked) {
            nativeInputCheckedSetter.call(this.nativeElement, !!checked);
            this.nativeElement.dispatchEvent(new Event('click', { bubbles: true }));
        }
    }]);

    return Main;
}(_Component2.default);

Main.propTypes = {
    label: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    checkedLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.number]),
    unCheckedLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element, _propTypes2.default.number])
};
Main.displayName = 'SwitchCheckbox';
exports.default = Main;